module.exports = __webpack_public_path__ + "static/media/Roboto-Black.a7c03a3d.otf";